<div class="jobseeker-stats-and-reports">
  <h3>Jobseekers</h3>
  <br />
  <div class="content">
    <div>
      <div>Total:</div>
      <div>
        {{ channelJobseekerStats && channelJobseekerStats[0]?.totalCount }}
      </div>
    </div>
    <div>
      <div>Current active:</div>
      <div>
        {{
          channelJobseekerStats && channelJobseekerStats[0]?.totalActiveCount
        }}
      </div>
    </div>
    <div>
      <div>Current active unique:</div>
      <div>
        {{ channelJobseekerStats && channelJobseekerStats[0]?.uniqueCount }}
      </div>
    </div>
    <div>
      <div>Current active with basic profile:</div>
      <div>
        {{
          channelJobseekerStats &&
            channelJobseekerStats[0]?.countWithBasicProfile
        }}
      </div>
    </div>
    <div>
      <div>Current active with complete profile:</div>
      <div>
        {{
          channelJobseekerStats &&
            channelJobseekerStats[0]?.countWithCompleteProfile
        }}
      </div>
    </div>

    <div *ngFor="let item of channelJobseekerStats">
      <div>Current active {{ item?.channel?.name }}:</div>
      <div>{{ item?.countPerChannel }}</div>
    </div>
  </div>
  <br />
  <div>
    <div>Reports:</div>
  </div>
</div>
